/* eslint-disable jsx-a11y/media-has-caption */
"use client";
import { createRef, useCallback, useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { useSearchParams } from "next/navigation";
import { Pagination, EffectCoverflow, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "./styles.css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { AbsoluteDiv } from "@/common/divs";
import { AlmostBoldText } from "@/common/texts";
import { NEUTRO_TITLES_COLOR } from "@/utils/constants";

const VideoCarousel: React.FC<{ city: string }> = ({ city }) => {
  //const [style, setStyle] = useState("wrapperSlide");
  const searchParms = useSearchParams();

  const [cityState, setCityState] = useState<string>(city);
  useEffect(() => {
    setCityState(searchParms.get("city") ?? city);
  }, [searchParms, city]);

  const videos = [
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_barcelona.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_experiencias_barcelona.webp",
      title: "Lo mejor de Barcelona",
      displayOn: "BARCELONA",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_san_sebastian.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_san_sebastian.webp",
      title: "Lo mejor de San Sebastián",
      displayOn: "SAN SEBASTIAN",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_sevilla.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_sevilla.webp",
      title: "Lo mejor de Sevilla",
      displayOn: "SEVILLA",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_madrid.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_madrid.webp",
      title: "Lo mejor de Madrid",
      displayOn: "MADRID",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_verano.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_verano.webp",
      title: "Lo mejor del verano",
      displayOn: "*",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_adrenalina.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_adrenalina.webp",
      title: "Vive la adrenalina",
      displayOn: "*",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_aire_libre.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_actividades_aire_libre.webp",
      title: "Conecta con la naturaleza",
      displayOn: "*",
      ref: createRef(),
    },

    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_creatividad.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_experiencias_talleres.webp",
      title: "Despierta tu lado creativo",
      displayOn: "*",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_gourmet.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_experiencias_gastronomicas.webp",
      title: "Placeres para el paladar",
      displayOn: "*",
      ref: createRef(),
    },

    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_para_locales.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_experiencias_locales.webp",
      title: "Experiencias únicas y originales",
      displayOn: "*",
      ref: createRef(),
    },

    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_tour_privado.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_tours_privados.webp",
      title: "Tours privados y exclusivos",
      displayOn: "*",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_tours.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_tours.webp",
      title: "Tours y cultura",
      displayOn: "*",
      ref: createRef(),
    },
    {
      videoSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_video_conjunto_transporte.mp4",
      posterSrc:
        "https://viajero-cdn.vee.travel/media/videos/vee_thumbnail_excursiones.webp",
      title: "Excursiones con transporte",
      displayOn: "*",
      ref: createRef(),
    },
  ];

  const getFilteredVideos = useCallback(() => {
    const auxFilteredVideos = [];
    for (let i = 0; i < videos.length; i++) {
      if (
        videos[i].displayOn == "*" ||
        cityState
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            videos[i].displayOn
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
          )
      ) {
        auxFilteredVideos.push(videos[i]);
      }
    }
    return auxFilteredVideos;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityState]);

  useEffect(() => {
    //@ts-ignore
    getFilteredVideos()[0].ref.current.load();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFilteredVideos]);

  const parseTitleToSlug = (title: string) => {
    return title.toLowerCase().replaceAll(" ", "-");
  };

  const isMobile = useMediaQuery("(max-width:640px)");

  return (
    <div
      style={{
        marginLeft: isMobile ? "10px" : "0px",
        height: isMobile ? "250px" : "500px",
        marginTop: "10px",
        backgroundColor: isMobile ? "white" : NEUTRO_TITLES_COLOR,
      }}
    >
      <Swiper
        spaceBetween={isMobile ? 10 : 70}
        slidesPerView={"auto"}
        navigation={isMobile ? false : true}
        grabCursor={false}
        centeredSlides={isMobile ? false : true}
        effect={isMobile ? "" : "coverflow"}
        watchSlidesProgress={true}
        loop={isMobile ? true : true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        }}
        modules={[EffectCoverflow, Navigation, Pagination]}
        onRealIndexChange={(swipper) => {
          //@ts-ignore
          getFilteredVideos()[swipper.previousRealIndex].ref.current.pause();
          //@ts-ignore
          getFilteredVideos()[swipper.realIndex].ref.current.play();
        }}
        className="mySwiper"
      >
        {getFilteredVideos().map((element, index) => {
          return (
            <SwiperSlide
              onClick={() => {
                if (searchParms.get("community")) {
                  window.history.pushState(
                    {},
                    "",
                    "city-landing?slug=" +
                      parseTitleToSlug(element.title) +
                      "&city=" +
                      cityState +
                      "&community=" +
                      searchParms.get("community"),
                  );
                  window.location.reload();
                } else {
                  window.history.pushState(
                    {},
                    "",
                    "city-landing?slug=" +
                      parseTitleToSlug(element.title) +
                      "&city=" +
                      cityState,
                  );
                  window.location.reload();
                }
              }}
              className={"wrapperSlide"}
              style={{ cursor: "pointer" }}
              key={index}
            >
              {" "}
              <video
                ref={element.ref as any}
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: isMobile ? "16px" : "30px",
                  maxWidth: "300px",
                }}
                controlsList="nodownload noplaybackrate"
                disablePictureInPicture={true}
                loop={true}
                preload="none"
                playsInline
                autoPlay={index === 0}
                poster={element.posterSrc}
                muted
              >
                <source src={element.videoSrc} type="video/mp4" />
              </video>
              <AbsoluteDiv
                bottom="20px"
                style={{ zIndex: "2" }}
                // onClick={() => {
                //   style == "wrapperSlide" ?
                //     setStyle("")
                //   : setStyle("wrapperSlide");
                // }}
              >
                <AlmostBoldText
                  style={{
                    textShadow:
                      "-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000",
                    color: "white",
                    textWrap: "balance",
                  }}
                >
                  {element.title}
                </AlmostBoldText>
              </AbsoluteDiv>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default VideoCarousel;
